export default __webpack_public_path__ + "images/f26e786192c5dd37a589f06a09b61ae2-drawingandpainting.jpg";